module.exports = __webpack_public_path__ + "static/media/ProductFeature1.ac29c21e.png";